import { VariableType } from 'json-to-graphql-query';
import type { FieldValue } from './types';

interface FieldNodeFields {
  id: FieldValue;
  name: FieldValue;
  dataType: FieldValue;
  fieldType: FieldValue;
  isEditable: FieldValue;
  isSystemField: FieldValue;
  slug: FieldValue;
  choiceList: FieldValue;
  choices: FieldValue;
}

interface ViewFieldNodeTypeResult {
  id: FieldValue;
  value: FieldValue;
  metadataFieldId: FieldValue;
  fieldLabel: FieldValue;
  sequence: FieldValue;
  field: FieldNodeFields | false;
}

interface AllViewFieldsQueryResult {
  query: {
    __variables: {
      globalId: 'String';
      view_ComponentName: 'String';
    };
    allViewFields: {
      totalCount: FieldValue;
      __args: {
        globalId: VariableType;
        view_ComponentName: VariableType;
      };
      edges: {
        node: ViewFieldNodeTypeResult;
      };
    };
  };
}

interface SharedViewFieldsQueryResult {
  query: {
    __variables: {
      globalId: 'String';
      view_ComponentName: 'String';
    };
    sharedViewFields: {
      totalCount: FieldValue;
      __args: {
        globalId: VariableType;
        view_ComponentName: VariableType;
      };
      edges: {
        node: ViewFieldNodeTypeResult;
      };
    };
  };
}

export const ViewFieldNodeType = (truify: boolean = false): ViewFieldNodeTypeResult => ({
  id: truify,
  value: truify,
  metadataFieldId: truify,
  fieldLabel: truify,
  sequence: truify,
  field: truify
    ? {
        id: truify,
        name: truify,
        dataType: truify,
        fieldType: truify,
        isEditable: truify,
        isSystemField: truify,
        slug: truify,
        choiceList: truify,
        choices: truify,
      }
    : false,
});

export const allViewFieldsQuery = (truify: boolean = false): AllViewFieldsQueryResult => ({
  query: {
    __variables: {
      globalId: 'String',
      view_ComponentName: 'String',
    },
    allViewFields: {
      totalCount: truify,
      __args: {
        globalId: new VariableType('globalId'),
        view_ComponentName: new VariableType('view_ComponentName'),
      },
      edges: {
        node: { ...ViewFieldNodeType(truify) },
      },
    },
  },
});

export const sharedViewFieldsQuery = (truify: boolean = false): SharedViewFieldsQueryResult => ({
  query: {
    __variables: {
      globalId: 'String',
      view_ComponentName: 'String',
    },
    sharedViewFields: {
      totalCount: truify,
      __args: {
        globalId: new VariableType('globalId'),
        view_ComponentName: new VariableType('view_ComponentName'),
      },
      edges: {
        node: { ...ViewFieldNodeType(truify) },
      },
    },
  },
});
